import React from 'react';
import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
}));
const bstyle =
    {backgroundColor:'#565656',color:'#fff'}

export default function BasicButtonGroup() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <ButtonGroup color="primary" aria-label="outlined primary button group">
        <Button size={'small'} style={bstyle}>3 </Button>
        <Button size={'medium'}>6</Button>
        <Button size={'large'}>9</Button>
        <Button size={'large'}>12</Button>
      </ButtonGroup>
     
    </div>
  );
}